module.exports = __webpack_public_path__ + "static/media/delaatsolar_24dpi_development.0062ada2.png";